<div id="ssHeaderLogoId">
    <a [routerLink]="['/']" [ngClass]="{ 'no-active': isSplashPage }">
        <div
            [ngClass]="{
                'splash-header': isSplashPage,
                'logo-header': !isSplashPage
            }"
        >
            <div
                class="row g-0 align-items-center"
                [ngClass]="{ padding: isSplashPage }"
            >
                <div
                    class="col-auto"
                    [ngClass]="{
                        logo: isSplashPage,
                        'logo-quotient': !isSplashPage
                    }"
                ></div>
                <div
                    class="col-auto"
                    [ngClass]="{
                        'logo-border-splash': isSplashPage,
                        'logo-border': !isSplashPage
                    }"
                ></div>
                <div
                    class="col-auto"
                    [ngClass]="{
                        'app-name-splash': isSplashPage,
                        'app-name': !isSplashPage
                    }"
                    >{{ appName }}</div
                >
            </div>
        </div>
    </a>
</div>
